/**
 * Indicates the type of transfer report.
 * tag: 2444
 * @readonly
 * @enum {number} (int)
 */
export enum TransferReportType {
  /** Submit */
  Submit = 0,
  /** Alleged */
  Alleged = 1,
}
